/* ローディング画面 */
import React from 'react';
import { Modal, Spinner } from 'react-bootstrap';

interface Props {
  show: boolean;
}

const LoadingModal: React.FC<Props> = ({ show }) => {
  return (
    <Modal id="loading-lodal" size="lg" centered show={show} animation={false} onHide={() => {}}>
      <Spinner animation="border" role="status" />
    </Modal>
  );
};

export default LoadingModal;
